import React from 'react'
import Plx from 'react-plx'
import classNames from 'classnames'

import styles from '@components/icons/animated/high_five.module.scss'

const HighFive = ({ className, ...rest }) => {
  const fadeEffect = {
    start: 'self',
    startOffset: 200,
    duration: 150,
    name: 'opacity',
    properties: [
      {
        startValue: 0,
        endValue: 1,
        property: 'opacity',
      },
    ],
  }

  const appearEffect = offset => ({
    start: 'self',
    startOffset: offset,
    duration: 25,
    name: 'opacity',
    properties: [
      {
        startValue: 0,
        endValue: 1,
        property: 'opacity',
      },
    ],
  })

  const rotateEffect = amount => ({
    start: 'self',
    startOffset: '50vh',
    duration: 80,
    name: 'rotation',
    properties: [
      {
        startValue: 0,
        endValue: amount,
        property: 'rotate',
      },
      {
        startValue: 0,
        endValue: amount,
        property: 'translateX',
      },
      {
        startValue: 0,
        endValue: 10,
        property: 'translateY',
      },
    ],
  })

  const plxData = {
    yellowHand: [fadeEffect, rotateEffect(11)],
    blueHand: [fadeEffect, rotateEffect(-10)],
    leftSpark: [appearEffect('40vh')],
    middleSpark: [appearEffect('45vh')],
    rightSpark: [appearEffect('50vh')],
  }

  return (
    <div className={classNames(styles.h5Animation, className)} {...rest}>
      <Plx
        className={classNames(styles.h5Animation__part, styles.h5YellowHand)}
        parallaxData={plxData.yellowHand}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 900">
          <path
            className={styles['cls-1']}
            d="M424.43 592.88c-5.3 11.7-10.45 23.5-16 35.1-7.58 15.92-14.56 32-19.9 48.88-4.14 13.06-6.82 26.46-10.24 39.7-4.68 18.07-8.54 36.3-10.2 54.93-1.82 20.18-5.27 40.16-7.44 60.3-1.13 10.48-2.6 20.92-3.78 31.4-1 8.74-2.48 17.4-4.28 26-6.93-.6-13.5-2.78-20.15-4.57a414.23 414.23 0 0 1-48.93-16.27c-8.08-3.3-16.12-6.67-24-10.37a437.15 437.15 0 0 1-59.24-33.46 5.9 5.9 0 0 1-1.44-1.4c1.6-13.72 3.4-27.4 4.8-41.14 1.93-18.82 4.4-37.56 6.7-56.33 1.67-13.58 3.9-27.1 3.95-40.85.06-18.72-4.37-36.63-8.76-54.7-5.1-20.92-16.54-38.68-25.9-57.5-8-16-15.55-32.28-19.43-49.8-3.62-16.38-7.54-32.75-9.42-49.5a260.6 260.6 0 0 1-2-34 31.94 31.94 0 0 1 4.9-16.77c1.86-3 5.06-4.5 8.15-5.7 8.86-3.4 17-.93 22.74 6.8 6.47 8.7 10.38 18.54 12.86 29 2.25 9.53 3.7 19.26 7 28.52 2.28 6.32 4.7 12.58 8.57 18.16a9.47 9.47 0 0 0 4.65 3.5c4.77 1.78 7.13.57 8.53-4.36 1.5-5.33 1.38-10.8 1.5-16.24q1.14-51.85 1.23-103.72c0-14.46.3-29 .94-43.4.5-11.35.52-22.7.38-34l1.1-10.1c.76-8.2 1.4-16.38 2.3-24.55.76-6.85 3.17-13.3 5.76-19.62 2.42-5.88 7.55-9.33 13.37-10.72 5.07-1.2 9.72 1.5 13.5 5a19.47 19.47 0 0 1 5.48 9.5 149.64 149.64 0 0 1 5.1 33.6c.55 13 2.4 25.9 3 38.88.65 15.54 1.1 31.08 2 46.6.78 13.32 1.44 26.65 1.83 40a13.53 13.53 0 0 0 1.85 7 5.08 5.08 0 0 0 5.36 2.43 4.9 4.9 0 0 0 4.27-3.56c.85-2.35.63-4.82.67-7.24q.8-52.05 1.57-104.1c.3-18.57 1-37.1 3.3-55.58 1.34-11 4.87-20.38 15.63-25.32 5.58-2.56 11.2-1.87 16.6.85 9.17 4.62 10.73 13.7 12 22.3 2.07 13.56 1.2 27.3 1 41-.24 17.07-.14 34.14-.17 51.2 0 24 .88 48.06.53 72.1-.1 6 2.25 8.3 6.86 7.2 2.3-.55 3.14-2.26 3.8-4.13 1.65-4.66 1.78-9.6 2.07-14.43 1.72-28.5 4.63-56.9 5.9-85.42.66-14.47 2.96-28.84 5.33-43.15.57-3.43.9-6.92 1.74-10.3 1.6-6.42 5.35-11.32 10.73-15.27 4.87-3.6 9.7-2.4 14.53-.68a18.62 18.62 0 0 1 10.3 8.4c1.58 5.2 3.2 10.38 3.5 15.87.15 6.95.27 13.9.5 20.85.32 10.22-1.13 20.38-1 30.58.4 27.27-2.16 54.45-2.2 81.7q0 10.8.13 21.57a17.6 17.6 0 0 0 .73 4.1 3.63 3.63 0 0 0 3.33 2.62 3.72 3.72 0 0 0 4.15-1.87 10.75 10.75 0 0 0 1.1-2.9c3.4-17.28 8-34.3 11.05-51.67 1.64-9.26 3.93-18.37 8.25-26.84a33.72 33.72 0 0 1 4.7-6.87c6.23-7.16 17.42-5.24 22.07 3.5a45.94 45.94 0 0 1 5.2 20c.67 17.08-1.28 34-3.8 50.88-.42 2.87-.7 5.75-1.05 8.63-4.2 32.5-5.13 82.16-39.77 169.75z"
          />
        </svg>
      </Plx>

      <Plx
        className={classNames(styles.h5Animation__part, styles.h5BlueHand)}
        parallaxData={plxData.blueHand}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 900">
          <path
            className={styles['cls-1']}
            d="M451.9 509c-3.17-14.1-6.63-28.16-9.4-42.35-1.8-9.17-3.54-18.43-3.26-27.9.23-7.8 2.68-14.12 10.5-17.6 5.42-2.4 10-1.44 14.45 2 2.4 4.07 5 8 7.17 12.2 6 11.56 9.48 24.1 13.68 36.36 6.34 18.5 12.7 37 18.52 55.67a8.3 8.3 0 0 0 2.27 3.86c2.6 2.3 5.66 1.4 6.8-1.87 1.04-3.08 0-6-.77-8.84-3.85-14.52-7.13-29.17-11-43.68-4.7-17.5-8.06-35.34-12.24-53a75 75 0 0 1-2-16.45c-.15-11.74 9.57-18.25 19.2-18.88 5.34-.35 9.16 3.4 12.2 7.56 4.23 5.8 6.34 12.6 8.8 19.2 5.55 14.86 9.28 30.3 13 45.66s9 30.37 12.48 45.83c.74 3.2 2.55 6.22 4.12 9.18 1 2 2.85 3.16 5.22 2.36s2.62-2.4 2.48-4.9c-.63-10.93-4.2-21.3-5.86-32q-3.5-22.4-7.6-44.7a136.22 136.22 0 0 1-2.5-20.6c-.3-10.85 5-18.05 17.28-16.44 3.64.48 6.7 3.07 9 6.14 3.9 5.3 6 11.43 8.33 17.5 5.1 13.54 8.47 27.63 13.47 41.22 3.94 10.72 8.06 21.42 11.05 32.5 4.5 16.62 10.4 32.85 13.88 49.77 1.07 5.22 2.58 6.36 6.43 6a3.16 3.16 0 0 0 3.28-2.95 51.13 51.13 0 0 0 .7-6.54c.22-11.32-.95-22.72 1.4-34 1.35-6.55 2.6-13.18 5.3-19.35 3.25-7.46 9.13-12.23 17.14-13.06 12.3-1.3 18.88 4.86 20.78 17.58a173.42 173.42 0 0 1 1.8 21c.16 6.2-.4 12.48-.42 18.73 0 10.43 1.93 20.7 2.56 31 .72 11.95.28 23.86-3.18 35.44-4.96 16.6-11.96 32.2-19.7 47.55-4.22 8.3-9.38 16.33-11.8 25.46-3.5 13.14-2.7 26.38.05 39.54 4.47 21.47 8.32 43.06 13.78 64.33 3.88 15.13 7.6 30.27 12.9 45 1.83 5.1 3.35 10.3 5.43 15.33-3.7 3.77-8.63 5.66-13.13 8.1a440.18 440.18 0 0 1-78.23 33.22c-14.63 4.6-29.35 8.88-44.52 11.4a80.6 80.6 0 0 0-1.3-8.53c-4-15.2-7-30.6-11.23-45.77-6.42-23.28-10.68-47.08-16.35-70.54-3.3-13.6-7.34-27-10.63-40.6-1.57-6.48-2.8-13.3-6.06-19.15-7.9-14.2-17.85-27-28.38-39.34-8.68-10.2-16.93-20.78-23.55-32.5-7.52-13.3-14.8-26.74-19.8-41.27-1.5-4.74-2.93-9.5-4.5-14.2-3.27-9.88-6.68-19.73-9.42-29.8a369.2 369.2 0 0 1-7.57-37c-.7-4.33-1.74-8.62-1.7-13.06.04-7.44 4-12.88 11.1-15 8.9-2.65 11.75-1.6 16.9 6.15 3.94 5.93 6.37 12.6 9 19.13 3 7.3 5.34 14.8 8 22.23 1.8 5.5 3.44 11 5.44 16.46 1.6 4.32 2.64 8.88 5.3 12.8a3.82 3.82 0 0 0 4.5 1.77c1.7-.47 2.2-1.9 2.1-3.57a37.72 37.72 0 0 0-.4-5.53c-3.17-14.95-7.88-29.46-11.27-44.3z"
          />
        </svg>
      </Plx>

      <Plx
        className={classNames(styles.h5Animation__part, styles.h5LeftSpark)}
        parallaxData={plxData.leftSpark}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 900">
          <g>
            <path
              className={styles['cls-1']}
              d="M193.83 210.15c.1 7.37-1.5 14.42-3.66 21.42-3.42 11.17-6.76 22.36-11.83 32.93a26 26 0 0 1-4.5 7c-1 1.08-1.9 1.14-2.8-.2a10.82 10.82 0 0 1-2.07-6.48c.27-8.67 2.86-16.82 5.48-25 3.26-10.13 6.24-20.36 11.26-29.84a17.5 17.5 0 0 1 4.2-5c.85-.75 1.9-1.57 3.1-1s.76 1.8.8 2.8c.08 1.05.03 2.22.03 3.37zM156.15 331c-1 10.53-3.83 21.22-7.07 31.88-2.8 9.17-6.37 17.84-12 25.6a17.4 17.4 0 0 1-1.3 1.62 2.52 2.52 0 0 1-2.83.82c-1.12-.43-.86-1.54-.83-2.43a110.45 110.45 0 0 1 3.2-20.88c2.75-11.94 7.93-23 12.4-34.24 1-2.43 2-5 4.6-6.34 1-.48 1.75-1.8 3.07-.92 1 .7.73 1.85.78 2.87 0 .5-.03 1-.03 2zM212 360.2c.08 1.8-.34 2.6-2.63 1.88-5.82-1.82-10.33-5.62-14.7-9.5-7.8-6.88-15.74-13.7-20.6-23.2-1.27-2.5-2.6-4.88-2.3-7.86.33-3.36 1.35-4 4.48-2.92 3.9 1.4 6.36 4.58 9.14 7.3a215.42 215.42 0 0 1 25.32 30.7c1.28 1.95 1.28 1.98 1.28 3.6z"
            />
            <path
              className={styles['cls-2']}
              d="M230.17 301.13c-17.46.16-34.88-.18-52.1-3.47a6.8 6.8 0 0 1-1-.25c-1.8-.64-4.46-.93-4.15-3.35.24-1.87 2.53-2.2 4.5-2.5 17.93-2.7 35.9-1.64 53.86-.53 6.92.24 10.54 3.23 11.17 4.17s1.42 2.66-.47 3.76-4.58 1.5-11.8 2.17z"
            />
            <path
              className={styles['cls-1']}
              d="M108.6 232.64c.94.7 2 1.43 3 2.22A86.42 86.42 0 0 1 125 248.8c6 7.6 12.8 14.66 17.16 23.44a52.36 52.36 0 0 1 3.3 8c.54 1.77-.94 3.28-2.5 2.6-1.93-.86-4.08-1.5-5.7-3.17-11.86-12.48-21.53-26.55-30.07-41.44a7.14 7.14 0 0 1-.95-2.93c-.13-1.46.68-2.4 2.36-2.66z"
            />
            <path
              className={styles['cls-2']}
              d="M129.2 300.6h3.56c2.38-.07 4.26.78 4.46 3.33a4.4 4.4 0 0 1-3.55 4.88 79.72 79.72 0 0 1-16.45 2.6c-9.8.72-19.58 1.57-29.4 1.7-2.16 0-4.62.26-4.86-2.57-.2-2.37 2.1-2.6 3.9-3.12 13.97-4.06 28.33-5.67 42.33-6.8z"
            />
          </g>
        </svg>
      </Plx>

      <Plx
        className={classNames(styles.h5Animation__part, styles.h5MiddleSpark)}
        parallaxData={plxData.middleSpark}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 900">
          <g>
            <path
              className={styles['cls-1']}
              d="M443.8 126.33c-1 2.42.54 5.58-1.12 8.36-1.28 2.14-2.52 2.58-4.6.73-3.53-3.1-4.7-7.48-6.3-11.47A183.4 183.4 0 0 1 421 87.06a117.77 117.77 0 0 1-1.93-23.12c.08-3.44 2.55-4.8 5-6.1s3.53 1.12 4.87 2.36c2.73 2.53 4 6 5.1 9.4a169.17 169.17 0 0 1 7.9 37.65c.56 6.22 1.65 12.4 1.85 19.08z"
            />
            <path
              className={styles['cls-2']}
              d="M512.9 193.35c2.05-.28 4.6 1.1 7.28 1.76 9.06 2.3 17.62 6 26.36 9.27a130.86 130.86 0 0 1 19.9 9.63c4.32 2.48 7.47 6.2 11 9.53 1.08 1 2.16 2.34 1.07 4-1 1.44-2.38 1.1-3.77.77a222.72 222.72 0 0 1-31.15-9.67 260.5 260.5 0 0 1-26-11.45c-5-2.6-9-6.5-13.7-9.45-1.5-.94-1-1.83.18-2.63 2.43-1.65 5.2-1.8 8.84-1.75z"
            />
            <path
              className={styles['cls-1']}
              d="M481.63 142.3c-1.47 0-2.4-.8-2-3.44 1.65-10.42 7.4-18.9 13-27.36 5.95-9 12.12-17.83 20.48-24.85 2.4-2 4.83-4 7.22-6 1.17-1 2.38-1.5 3.76-.53s1.1 2.1.76 3.44c-2.1 8.57-6.57 16-11 23.53-3.4 5.76-7 11.38-10.8 16.92-4.56 6.75-9.88 12.83-17.04 17a6.63 6.63 0 0 1-4.37 1.27z"
            />
            <path
              className={styles['cls-3']}
              d="M340.8 127.2c2.8.82 6.58 1.84 10.3 3.06 8.67 2.85 17.25 5.94 26 8.67 8.2 2.57 15.36 7 22.62 11.36 1.7 1 3.52 1.77 5.2 2.77 1.4.82 3.07 1.84 2.2 3.75a3.6 3.6 0 0 1-4.38 2c-6.45-1.45-13-2.67-19.35-4.33-14.88-3.87-29.2-9.15-42.5-17-2-1.18-4.08-2.08-5-4.55-1.6-4.23-.7-5.7 4.9-5.75zM558.7 146a60.58 60.58 0 0 1 10.86 1.25c1.3.23 2.52.44 2.64 2.18s-.9 2.18-2.1 2.83c-6.34 3.48-13.32 5.35-20 8-9.16 3.72-19 4.1-28.44 6.06-3.83.8-7.32-.55-10.48-2.78-2-1.44-1.88-2.83.15-4a45.7 45.7 0 0 1 8.47-4c9.7-3.14 19.5-5.92 29.45-8.1 3.5-.7 7.1-1.07 9.46-1.44zM406.54 187.66a42.38 42.38 0 0 1 4.82.4c1.25.25 2.6.9 2.87 2.25.3 1.54-.92 2.42-2 3.36-4.65 4-10.5 5.24-16 7.07C386.26 204 376 206 365.83 208a25.3 25.3 0 0 1-10.36-.33c-2-.44-2.72-1.44-1.46-3.5a16.38 16.38 0 0 1 9.78-7.7c12.56-3.75 25.4-6.18 38.25-8.6a24.83 24.83 0 0 1 4.5 0z"
            />
            <path
              className={styles['cls-4']}
              d="M411 268.82a49.25 49.25 0 0 0 8.93-10.12 181.67 181.67 0 0 0 16.75-30.33 38.4 38.4 0 0 0 3-11c.13-1.22.16-2.68-1.22-3.38s-1.87.62-2.63 1.2a45.2 45.2 0 0 0-4.8 4c-9.82 9.86-17 21.57-23.57 33.73-4.3 6.32-11.46 29.84 3.54 15.9z"
            />
            <path
              className={styles['cls-2']}
              d="M494 262.57a41.9 41.9 0 0 1-1 4.13c-.52 1.47-.45 3.54-2.4 3.93-2.1.42-3.53-1.2-4.54-2.67C478.2 256.43 472.38 244 471 230c-.27-2.67.72-5.3 1.57-7.77s2.82-2.7 4.8-.74c4 4 6.34 9.12 9 14 4.36 8 5.9 17 7.67 25.83a11.84 11.84 0 0 1-.04 1.24z"
            />
          </g>
        </svg>
      </Plx>

      <Plx
        className={classNames(styles.h5Animation__part, styles.h5RightSpark)}
        parallaxData={plxData.rightSpark}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 900">
          <g>
            <path
              className={styles['cls-1']}
              d="M798.08 379.66c.05 3-1.62 4.17-4.9 3.3-6.7-1.8-12.53-5.42-18.14-9.28A128.1 128.1 0 0 1 748.4 350c-2.9-3.52-3.2-5.4-1.06-7.9 1.8-2.1 3.56-2.64 6.33-1.27a99.8 99.8 0 0 1 27.44 19.72c4.85 4.95 10.57 9 14.9 14.5 1.1 1.38 2.16 2.72 2.08 4.6z"
            />
            <path
              className={styles['cls-2']}
              d="M698.15 313.14a16.9 16.9 0 0 1-6.45-1.85c-10.5-4.5-19.87-10.87-29-17.63a128.7 128.7 0 0 1-21.4-20.17 10.7 10.7 0 0 1-2.6-4.5c-.23-1-.5-2.2.4-2.93s1.76 0 2.58.46a200 200 0 0 1 22.48 13.65c8.48 5.84 16.45 12.36 24.8 18.38 4.07 2.94 7.22 6.83 10.82 10.26.86.82 2.42 1.58 1.88 3-.6 1.7-2.38 1.02-3.5 1.32zM702.5 420.67c0-10.8 1.8-21.37 3.92-31.9 1-5.23 1.52-10.58 3.53-15.55.66-1.62.48-4.36 3.4-4 2.56.3 5.3 3.77 5 6.3-.8 6-.5 12-1.3 18-1.25 9.4-1.93 18.88-4.13 28.13-1.12 4.72-2.66 9.35-4 14-.44 1.5-1.14 3.13-2.88 3s-2.14-2-2.5-3.42c-1.23-4.8-.96-9.68-1.04-14.56zM637.7 379.95c-2.94-.1-3.5-1.3-2.14-3.66 5-8.57 12.62-14.45 20.44-20 7.25-5.14 14.3-10.67 22.6-14.2a32 32 0 0 1 5.84-2.08c1.22-.26 2.63-1 3.5.3a3.66 3.66 0 0 1-.33 4.53 85.54 85.54 0 0 1-17 16.32c-7.76 5.42-15.82 10.38-23.82 15.45-2.87 1.87-6.14 2.52-9.1 3.33zM754.5 310.4a4.3 4.3 0 0 1-4.87-2.63c-1.08-2.37 1.14-3.12 2.5-3.85 12.67-6.75 25.4-13.38 39.53-16.66 3.83-.9 7.6-2 11.4-3a14.9 14.9 0 0 1 2.73-.38c1.43-.1 2.85.07 3.55 1.57a3 3 0 0 1-1.16 3.7 79.1 79.1 0 0 1-9.45 7 104.94 104.94 0 0 1-34 12.56c-3.4.64-6.84 1.14-10.26 1.7z"
            />
            <path
              className={styles['cls-3']}
              d="M737.38 241.55c-.85 12.66-.84 25.4-3.47 37.9a39.65 39.65 0 0 1-4.53 11.9c-.6 1-1 2.7-2.58 2.46s-1.7-1.8-2.1-3a32.76 32.76 0 0 1-1.64-12.6 253.6 253.6 0 0 1 6.72-45.53c.53-2.26 1.2-4.25 3.9-3.8 2.43.38 3.72 2.1 3.7 4.68s0 5.34 0 8z"
            />
          </g>
        </svg>
      </Plx>
    </div>
  )
}

export default HighFive
